import { render, staticRenderFns } from "./booleanIcon.vue?vue&type=template&id=052b1b18&scoped=true"
import script from "./booleanIcon.vue?vue&type=script&lang=js"
export * from "./booleanIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052b1b18",
  null
  
)

export default component.exports